/**
 * Иконки инлайном.
 *
 * Спрайт или библиотека здесь были бы дороже самого набора: иконок несколько
 * штук, и каждая — один путь. `aria-hidden` на всех: подпись даёт кнопка, а
 * дубль в озвучке только мешает.
 */

const BASE = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
} as const;

export function ChevronLeft(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}

export function ChevronDown(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function ChevronRight(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}

export function Check(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}

export function Plus(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

export function Times(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}

export function Inbox(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M4 13h4l2 3h4l2-3h4" />
      <path d="M6 5h12l3 8v6H3v-6z" />
    </svg>
  );
}

/** Повтор (3.19): две стрелки по кругу, как у «повторить» в плеерах. */
export function Repeat(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M4 12V9a3 3 0 0 1 3-3h13l-3-3m3 3l-3 3" />
      <path d="M20 12v3a3 3 0 0 1-3 3H4l3 3m-3-3l3-3" />
    </svg>
  );
}

export function Calendar(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4M16 3v4M3 11h18" />
    </svg>
  );
}

/**
 * Зонтик — задача, под которой лежат другие (3.8.1). Значок временный: так его
 * и попросил владелец, «пока».
 */
export function Umbrella(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M12 3a9 9 0 0 0-9 9h18a9 9 0 0 0-9-9z" />
      <path d="M12 12v6a2 2 0 0 0 4 0" />
    </svg>
  );
}

/** Замок — задачу держит незакрытая зависимость (3.9.4). */
export function Lock(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  );
}

/** Чек-лист: две отметки и две строки (3.7.3). */
export function Checklist(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M3 7l2 2 3-3" />
      <path d="M3 16l2 2 3-3" />
      <path d="M12 7h9M12 17h9" />
    </svg>
  );
}

/*
 * Значков «список» и «доска» здесь больше нет: переключателя формата не
 * существует, формат выбирает ширина экрана (3.1.1).
 */

/** Дискета: правка ещё уезжает. Значок, а не слово, — чтобы подвал не дёргался. */
export function Save(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M5 4h11l3 3v13H5z" />
      <path d="M8 4v5h7V4M8 20v-6h8v6" />
    </svg>
  );
}

/** Восклицание: срок горит. Цвет говорит насколько, значок — что вообще. */
export function Alarm(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v6M12 16.5v.5" />
    </svg>
  );
}

/** Карандаш: подсказка, что поле рядом правится. */
export function Pencil(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M4 20h4l10-10a2.8 2.8 0 0 0-4-4L4 16v4z" />
      <path d="M13.5 6.5l4 4" />
    </svg>
  );
}

export function Search(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </svg>
  );
}

/** Стрелка «перейти» — у связанной задачи в карточке: переход к другой задаче. */
export function ArrowUpRight(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M7 17L17 7M9 7h8v8" />
    </svg>
  );
}

export function Play(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M7 4l12 8-12 8V4z" />
    </svg>
  );
}

export function Pause(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M9 5v14M15 5v14" />
    </svg>
  );
}

/** Стрелки вверх-вниз: тот же знак раскрывающегося списка, что у браузера. */
export function UpDown(): React.ReactElement {
  return (
    <svg {...BASE} className="icon">
      <path d="M8 9l4-4 4 4M8 15l4 4 4-4" />
    </svg>
  );
}
